/**
 * notifications.js
 * ----------------
 * Préférences de notification de la direction.
 *
 * Backend : core/notifications_views.py — permission IsAdminLevel.
 *
 * Le catalogue (événements, canaux, disponibilité) est servi par l'API et non
 * codé ici : c'est le serveur qui sait quels canaux savent réellement envoyer.
 * Une colonne dont `disponible` est faux se rend désactivée, avec son `motif`.
 */
import axiosClient from "../axiosClient";

/** GET /directeur/notifications/preferences/
 *  -> { canaux: [{code, libelle, disponible, motif}], evenements: [...] } */
export async function getPreferencesNotification() {
  const { data } = await axiosClient.get("/directeur/notifications/preferences/");
  return data || {};
}

/** POST /directeur/notifications/preferences/ — bascule un interrupteur.
 *  Renvoie le catalogue complet à jour (pas de recalcul côté client). */
export async function majPreferenceNotification({ evenement, canal, actif }) {
  const { data } = await axiosClient.post("/directeur/notifications/preferences/", {
    evenement,
    canal,
    actif,
  });
  return data;
}

/** POST /directeur/notifications/apercu/ — s'envoie à soi-même le digest qu'on
 *  recevrait maintenant. Répond { envoye: false } quand il n'y a rien à dire. */
export async function envoyerApercuNotification(cadence) {
  const { data } = await axiosClient.post("/directeur/notifications/apercu/", { cadence });
  return data;
}
